import { dotContainerTemplate } from "./templates";
import wrapNode from "../../utils/wrapNode";
import getDevice from "../../utils/getDevice";

function createProductsContext(dataset) {
    let productContainer =  document.createElement('div'),
        showButton = document.createElement('button'),
        hideButton = document.createElement('button');

    productContainer.className = "product-image-container";
    hideButton.className = 'hide-products hidden';
    hideButton.appendChild(document.createTextNode(dataset && dataset.hideProductsCaption? dataset.hideProductsCaption: 'TAP TO HIDE PRODUCTS'));
    showButton.className = 'view-products';
    showButton.appendChild(document.createTextNode(dataset && dataset.viewProductsCaption? dataset.viewProductsCaption: 'TAP TO VIEW PRODUCTS'));

    return {
        productContainer: productContainer,
        hideButton: hideButton,
        showButton: showButton
    };
}

function generateProductDotsContainer(areaMap, context) {
    let productDotContainer =  document.createElement('div');
    productDotContainer.className = "products-container hidden";

    areaMap.forEach(area => {
        productDotContainer.appendChild(dotContainerTemplate(area));
    });

    context.productContainer.appendChild(productDotContainer);
}

function initProductsButton(image, context) {
    let productContainer = context.productContainer;
    wrapNode(image.closest('.share-tab-img') || image, productContainer);

    productContainer.appendChild(context.showButton);
    productContainer.appendChild(context.hideButton);
}

function initAreasImage(image, context) {
    const mapName = (image['useMap'] || '').replace(/^#/, '');
    const imageMap = document.querySelectorAll(`map[name="${mapName}"]`)
    const buyCaption =  image.closest('article').dataset.buyCaption || 'Buy'
    initAreas(imageMap, buyCaption, context);
}

function initAreasLeadMedia(image, mediaHtml, context) {
    const mediaHtmlWrapper = document.createElement('div');
    mediaHtmlWrapper.innerHTML = mediaHtml;
    const imageMap = mediaHtmlWrapper.querySelectorAll('map');

    const buyCaption =  image.closest('article').dataset.buyCaption || 'Buy'

    initAreas(imageMap, buyCaption, context);
}

function initAreas(imageMap, buyCaption, context) {
    imageMap.forEach(map => {
        const areaList = Array.from(map.querySelectorAll('area')).map(area => {
            const [left, top] = (area.coords || '').split(',');
            return left && top ? {
                style: `top: ${top}%; left: ${left}%;`,
                title: area.title,
                href: area.href,
                price: area.dataset.price,
                thumbnail: area.dataset.imageSrc,
                buyCaption,
            } : false;
        }).filter(Boolean);
        generateProductDotsContainer(areaList, context)
    });
}


function toggleProductDots(event) {
    event.preventDefault();
    event.currentTarget.parentNode.querySelectorAll('.products-container, .hide-products, .view-products, .share-media-panel').forEach(elem => {
        elem.classList.toggle('hidden');
    });
}

function hideAllCards(context) {
    context.productContainer.querySelectorAll('.details-container').forEach(detailsCont => {
        detailsCont.classList.toggle('hidden', true);
    });
}

function initListeners(context) {
    context.showButton.addEventListener("click", toggleProductDots);
    context.hideButton.addEventListener("click", toggleProductDots);

    context.productContainer.querySelectorAll('.product-dot-cont').forEach(dot => {
        dot.addEventListener("click", (event) => {
            let dot  = event.currentTarget,
                card = (getDevice() === "mobile") ? dot.querySelector('.details-container.mobile'): dot.querySelector('.details-container.desktop'),
                cardParent = card.closest('.product-image-container'),
                open = card.classList.contains('hidden');

            hideAllCards(context);
            card.classList.toggle('hidden', !open); // toggle

            if (open) {
                let cardOffset = card.getBoundingClientRect(),
                    parentOffset = cardParent.getBoundingClientRect(),

                    cardEnd = cardOffset.left + window.scrollX + card.clientWidth - 80,
                    parentEnd = parentOffset.left + window.scrollX + cardParent.clientWidth,
                    cardBottom = cardOffset.top + window.scrollY + card.clientHeight,
                    parentBottom = parentOffset.top + window.scrollY + cardParent.clientHeight;

                if (getDevice() === "mobile") {
                    let mobileCard = dot.querySelector('.details-container.mobile');
                    mobileCard.style.top = (cardParent.clientHeight - mobileCard.clientHeight)/2 + 'px';
                    mobileCard.style.left = cardParent.clientWidth - mobileCard.clientWidth + 'px';
                    window.addEventListener("scroll", function() {
                        hideAllCards(context);
                    });
                } else {
                    if (cardOffset.left - parentOffset.left < card.clientWidth/2) {
                        card.classList.add('left');
                    }
                    if (parentEnd - cardEnd < card.clientWidth/2) {
                        card.classList.add('right');
                    }
                    if (parentBottom - cardBottom < -30) {
                        let pos = (card.clientHeight + 36) * -1;
                        card.classList.add('bottom');
                        card.style.top = `${pos}px`;
                    }
                }
            } else {
                window.removeEventListener("scroll", hideAllCards, true);
            }
        });
    });
}

function initLeadMediaProducts(bootstrap) {
  if (!!bootstrap.post.media_html.match(/<map/g)) {
    const context =  createProductsContext();
    const image = document.querySelector('.widget__image');
    if (image.closest('.product-image-container')) {
      return;
    }
    initProductsButton(image, context);
    initAreasLeadMedia(image, bootstrap.post.media_html, context);
    initListeners(context);
  }
}

export default function initProducts(_context, image) {
    if(image.querySelectorAll('.product-image-container').length) {
      return;
    }

    if (image['useMap']) {
      const context =  createProductsContext(image.closest('article').dataset);
      initProductsButton(image, context);
      initAreasImage(image, context);
      initListeners(context);
    } else {
      REBELMOUSE_STDLIB.getBootstrap().then(initLeadMediaProducts);
    }

}
